<script setup lang="ts">
import { useAttrs } from 'vue'
import { cx } from './cx'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  class?: string
  modelValue?: string | number
}>()

const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const attrs = useAttrs()

function onInput(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}
</script>

<template>
  <input
    v-bind="attrs"
    :value="modelValue"
    :class="cx('field', props.class)"
    @input="onInput"
  />
</template>
